"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));

var _netUtils = require("@onviobr/net-utils");

var _constants = require("../utils/constants");

var _default = function _default(env) {
  var fetchUnregister = (0, _netUtils.addInputInterceptor)(function (input, options) {
    var _context;

    if (input instanceof Request) {
      console.warn('When the input to a fetch call is a Request instance, it can not be modified');
      return [input, options];
    }

    var parsedUrl = new _url.default(input, window.location.href);

    if ((0, _includes.default)(_context = parsedUrl.href).call(_context, 'api/auth')) {
      parsedUrl.searchParams.append('env', env);
    }

    return [parsedUrl.href, options];
  }, [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]);
  var xhrUnregister = (0, _netUtils.addPostInterceptor)(function (method, url, async, user, password) {
    var _context2;

    var parsedUrl = new _url.default(url, window.location.href);

    if ((0, _includes.default)(_context2 = parsedUrl.href).call(_context2, 'api/auth')) {
      if (parsedUrl.searchParams.get('env') !== env) {
        parsedUrl.searchParams.append('env', env);
        this.open(method, parsedUrl.href, async !== null && async !== void 0 ? async : false, user, password);
      }
    }
  }, [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]);
  return function () {
    fetchUnregister();
    xhrUnregister();
  };
};

exports.default = _default;
